import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

/**
 * toppers ReviewsPage ``footer_content`` assembly: collapses the whole-field
 * StreamField into a SINGLE ``{% include_react %}`` island rendered inside
 * ``.reviews-standalone-footer__container`` (shown only when ``not show_sources``).
 * The surrounding ``.reviews-standalone-footer`` chrome is rendered separately.
 *
 * PER-BLOCK WRAPPER: wagtail ``StreamBlock`` render wraps EACH child in
 * ``<div class="w-block-{type} block-{type}">``; we reproduce that wrapper per
 * child so the DOM matches a native StreamField render.
 *
 * SERIALIZATION SHAPE: ``text`` is a thelabui ``RichTextBlock`` ->
 * ``ClientRenderingBarrier``, so its serialized value is the rendered rich text,
 * i.e. ``<div class="rich-text">...</div>``. We raw-inject that into the
 * load-bearing ``.reviews-standalone-footer__block`` wrapper, which is built here
 * rather than in a server template.
 *
 * NO GLOBAL JS: static content.
 */
export const ReviewsPageFooterContent = (
    props: Immutable<{
        page: Pick<
            templates.ReviewsPageDocumentTemplate["page"],
            "footer_content"
        >;
    }>,
): React.JSX.Element | null => {
    const footerContent = props.page.footer_content;
    if (!footerContent) {
        return null;
    }
    return (
        <>
            {footerContent.value.map((block) => (
                <div
                    key={block.id}
                    className={`w-block-${block.type} block-${block.type}`}
                >
                    <div
                        className="reviews-standalone-footer__block"
                        dangerouslySetInnerHTML={{ __html: block.value }}
                    />
                </div>
            ))}
        </>
    );
};
